import {
  useEffect,
  useState,
  Fragment,
  useRef,
  useLayoutEffect,
  useCallback,
} from "react";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import "./style.css";
import ArrowRightOutlinedIcon from "@mui/icons-material/ArrowRightOutlined";
import logo from "../../assets/image/CMS_LOGO.svg";
import logo2 from "../../assets/image/CMS_LOGO2.svg";
import logoDonor from "../../assets/Donor/Donor-logo.svg";
import logoDonor2 from "../../assets/Donor/Donor-small.svg";
import routes from "../../routes";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { styled } from "@mui/material";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  PopoverBody,
  UncontrolledPopover,
} from "reactstrap";
import {
  Tooltip,
  useMediaQuery,
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Box,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import Client from "../../assets/Blue-sidebar-icon/Customer.svg";
import Client2 from "../../assets/orange-icon/Customer.svg";
import Quote from "../../assets/Blue-sidebar-icon/Quote.svg";
import Quote2 from "../../assets/orange-icon/Quote.svg";
import Contract from "../../assets/Blue-sidebar-icon/Contract.svg";
import Contract2 from "../../assets/orange-icon/Contract.svg";
import Invoice from "../../assets/Blue-sidebar-icon/Invoice.svg";
import Invoiceorange from "../../assets/orange-icon/Invoice.svg";
import AxiosInstance from "../../utils/axiosInstance";
import CreateWhite from "../../assets/White-sidebar-icon/Create.svg";
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
import WhiteButton from "../Button/WhiteButton";
import { handleAuth } from "../Login/Auth";
import { useUserType } from "../../contexts/UserTypeContext";
import DonorCustomer from "../../assets/Donor/Donor-customer.svg";
import DonorInvoice from "../../assets/Donor/Invoice-donor.svg";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import { logout } from "../../utils/auth";
import { getItem } from "../../utils/storage";
import { getCjNavMuiIcon } from "./cjNavIcons";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import ArticleIcon from "@mui/icons-material/Article";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import StickyNote2OutlinedIcon from "@mui/icons-material/StickyNote2Outlined";

/** "+ Create New" MUI menu — icon tiles + width tuned to content (min ~220px) */
const SIDEBAR_CREATE_TILE = {
  customer: ["#EFF6FF", "rgba(29, 78, 216, 0.2)", "#1D4ED8"],
  quote: ["#DCFCE7", "rgba(4, 120, 87, 0.18)", "#047857"],
  request: ["#FEF3C7", "rgba(180, 83, 9, 0.22)", "#B45309"],
  contract: ["#FFEDD5", "rgba(194, 65, 12, 0.22)", "#C2410C"],
  invoice: ["#EDE9FE", "rgba(91, 33, 182, 0.2)", "#5B21B6"],
};
const SIDEBAR_CREATE_ICON = {
  customer: PeopleAltIcon,
  quote: RequestQuoteIcon,
  request: StickyNote2OutlinedIcon,
  contract: ArticleIcon,
  invoice: ReceiptLongIcon,
};
const SIDEBAR_CREATE_MENU_MIN_PX = 196;

const sidebarCreateMenuItemSx = {
  gap: 1,
  py: 0.75,
  px: 1.25,
  minHeight: 42,
  borderRadius: "8px",
  mx: 0.5,
  my: 0.25,
  alignItems: "center",
  justifyContent: "flex-start",
  whiteSpace: "nowrap",
  width: "100%",
  boxSizing: "border-box",
  minWidth: 0,
  "&:hover": { backgroundColor: "rgba(6, 49, 100, 0.06)" },
};

const sidebarCreateMenuLabelSx = {
  m: 0,
  fontWeight: 500,
  fontSize: "15px",
  lineHeight: 1.35,
  color: "#374151",
};

function SidebarCreateMenuIconTile({ kind, useCjIcons, imgSrc }) {
  const [bg, border, col] = SIDEBAR_CREATE_TILE[kind];
  const Cmp = SIDEBAR_CREATE_ICON[kind];
  return (
    <Box
      // JOB-3378: data attribute lets admin-dark-overrides.css brighten
      // each kind's icon for dark mode. Without it the brand-color icons
      // (#1D4ED8 etc.) become invisible inside the global popover tile.
      data-cj-create-kind={kind}
      sx={{
        width: 32,
        height: 32,
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        backgroundColor: bg,
        border: `1px solid ${border}`,
      }}
    >
      {useCjIcons && Cmp ? (
        <Cmp sx={{ fontSize: 18, color: col }} />
      ) : (
        <Box
          component="img"
          alt=""
          src={imgSrc || "/placeholder.svg"}
          sx={{ width: 20, height: 20, objectFit: "contain" }}
        />
      )}
    </Box>
  );
}

/** Section labels for Cloud Job Manager sidebar (company, staff, customer portals). */

/**
 * Top-level nav groups that get inline-collapse treatment (chevron + smooth
 * Collapse drawer below the row), as opposed to the legacy popover-flyout.
 * Add a name here when introducing a new collapsible group in routes.jsx.
 *
 * Phase 8 (JOB-3314): "Engagement" added alongside the existing "Email".
 */
const CJ_INLINE_GROUPS = ["Email", "Engagement"];

/**
 * True when the current URL is under one of an inline group's children.
 * Drives auto-open of the drawer when navigating directly to a deep route.
 *
 * For Email we keep a curated allowlist (matches `/email-campaign-details/:id`
 * style routes that don't appear directly in routes.jsx). For other groups we
 * derive the path list from the prop's children at lookup time.
 */
const EMAIL_DEEP_PATHS = [
  "/templates",
  "/Email-logs",
  "/email-campaign",
  "/add-templates",
  "/add-new-email",
  "/add-email-campaign",
  "/email-campaign-details",
];

const isInlineGroupChildPathActive = (prop, pathname, companySlug) => {
  if (!pathname || !companySlug || !prop) return false;
  if (!pathname.includes(`/${companySlug}/`)) return false;
  const subs = prop.name === "Email"
    ? EMAIL_DEEP_PATHS
    : (prop.children || []).map((c) => c?.path).filter(Boolean);
  return subs.some((p) => pathname.includes(p));
};

// Backward-compat alias — still referenced elsewhere by name.
const isEmailNavChildPathActive = (pathname, companySlug) =>
  isInlineGroupChildPathActive({ name: "Email" }, pathname, companySlug);

/** True when URL is under any /engagement/* path (Phase 2–7 children). */
const isEngagementNavChildPathActive = (pathname, companySlug) => {
  if (!pathname || !companySlug) return false;
  if (!pathname.includes(`/${companySlug}/`)) return false;
  return pathname.includes("/engagement/");
};

const getCjNavSection = (prop, layout) => {
  if (!prop || prop.layout !== layout) return null;
  if (prop.isCollapse && CJ_INLINE_GROUPS.includes(prop.name)) return "TOOLS";
  const p = prop.path || "";
  if (layout === "/:CompanyUrl") {
    if (["/index", "/schedule", "/todays-appointments"].includes(p)) return "MAIN";
    if (
      ["/customer", "/donor", "/service-requests", "/quotes", "/contract", "/invoice"].includes(
        p
      )
    )
      return "CRM";
    if (
      ["/materials-labor", "/manageteam", "/pos", "/accept-donation"].includes(p)
    )
      return "OPERATIONS";
    if (["/company-reports", "/reports"].includes(p)) return "TOOLS";
    return null;
  }
  if (layout === "/:CompanyUrl/staff-member") {
    if (["/index", "/worker-schedule", "/worker-todays-appointments"].includes(p))
      return "MAIN";
    if (
      [
        "/worker-customer",
        "/worker-service-requests",
        "/worker-quote",
        "/worker-contract",
        "/worker-invoice",
        "/worker-invoice-detail",
      ].includes(p)
    )
      return "CRM";
    if (
      ["/worker-materials-labor", "/worker-appointments", "/worker-time-entry"].includes(p)
    )
      return "OPERATIONS";
    if (["/worker-reports"].includes(p)) return "TOOLS";
    return null;
  }
  if (layout === "/:CompanyUrl/customers") {
    if (["/index", "/customer-schedule", "/todays-appointments"].includes(p)) return "MAIN";
    if (["/customer-service-requests", "/quotes", "/contract", "/invoice"].includes(p)) return "CRM";
    if (["/General-ledger", "/appointment", "/notes"].includes(p)) return "TOOLS";
    return null;
  }
  return null;
};

const formatCjRoleLabel = (role) => {
  switch (role) {
    case "Admin":
      return "Super Admin";
    case "Company":
      return "Admin";
    case "Worker":
      return "Worker";
    case "Customer":
      return "Customer";
    case "Donor":
      return "Donor";
    default:
      return role || "User";
  }
};

/** `/v1/auth/token_data` returns `{ data: { Role, EmailAddress, ... }, themes, logo }` */
const getAuthProfile = (tokenDecode) =>
  tokenDecode?.data != null &&
  typeof tokenDecode.data === "object" &&
  tokenDecode.data.Role != null
    ? tokenDecode.data
    : tokenDecode;

const isGarbageDisplayName = (s) => {
  const t = (s || "").trim();
  if (!t) return true;
  if (/^undefined(\s+undefined)?$/i.test(t)) return true;
  if (/^undefined\b/i.test(t)) return true;
  return false;
};

/** CJ footer: show real name only — never use email; company admins often use OwnerName */
const buildSidebarDisplayName = (profile) => {
  const fromFull =
    profile?.FullName != null ? String(profile.FullName).trim() : "";
  const fromParts = [profile?.FirstName, profile?.LastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  const owner =
    profile?.OwnerName != null ? String(profile.OwnerName).trim() : "";
  const business =
    profile?.BusinessName != null ? String(profile.BusinessName).trim() : "";
  const company =
    profile?.CompanyName != null ? String(profile.CompanyName).trim() : "";

  let name = fromFull || fromParts || owner || business || company || "";
  if (isGarbageDisplayName(name)) {
    name = fromParts || owner || business || company || "";
  }
  if (isGarbageDisplayName(name)) {
    name = owner || business || company || "";
  }
  if (isGarbageDisplayName(name)) {
    name = business || company || "";
  }
  if (isGarbageDisplayName(name)) name = "";
  return name.trim() || "User";
};

const roleFallbackInitials = (role) => {
  switch (role) {
    case "Admin":
      return "SA";
    case "Company":
      return "AD";
    case "Worker":
      return "WK";
    case "Customer":
      return "CU";
    case "Donor":
      return "DN";
    default:
      return "?";
  }
};

const buildSidebarInitials = (displayName, role) => {
  const t = (displayName || "").trim();
  if (!t || t === "User" || isGarbageDisplayName(t)) {
    return roleFallbackInitials(role);
  }
  const parts = t.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase().slice(0, 2);
  }
  if (parts.length === 1 && parts[0].length >= 2) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return parts[0]?.[0]?.toUpperCase() || roleFallbackInitials(role);
};

/** Single canonical order per layout so section headers (MAIN, CRM, …) appear once. */
const CJ_FLAT_ORDER = {
  "/:CompanyUrl": [
    "/index",
    "/schedule",
    "/todays-appointments",
    "/customer",
    "/service-requests",
    "/quotes",
    "/contract",
    "/invoice",
    "/materials-labor",
    "/manageteam",
    "/pos",
    "__email__",
    // Phase 8 (JOB-3314): Engagement Hub group sits next to Email in the
    // TOOLS section. Synthetic key — the group has no top-level path.
    "__engagement__",
    "/company-reports",
  ],
  "/:CompanyUrl/staff-member": [
    "/index",
    "/worker-schedule",
    "/worker-todays-appointments",
    "/worker-customer",
    "/worker-service-requests",
    "/worker-quote",
    "/worker-contract",
    "/worker-invoice",
    "/worker-invoice-detail",
    "/worker-materials-labor",
    "/worker-appointments",
    "/worker-time-entry",
    "/worker-reports",
  ],
  "/:CompanyUrl/customers": [
    "/index",
    "/customer-schedule",
    "/todays-appointments",
    "/customer-service-requests",
    "/quotes",
    "/contract",
    "/invoice",
    "/appointment",
    "/notes",
  ],
};

const getCjFlatOrder = (prop, layout) => {
  if (!prop || prop.layout !== layout) return 9999;
  // Inline-collapse groups don't have a top-level path; synthesize a stable
  // key so they slot into CJ_FLAT_ORDER at a known position. New inline
  // groups should add both an entry to CJ_INLINE_GROUPS *and* to the
  // CJ_FLAT_ORDER lists below the relevant layout.
  let key = prop.path || "";
  if (prop.isCollapse && prop.name === "Email") key = "__email__";
  if (prop.isCollapse && prop.name === "Engagement") key = "__engagement__";
  const list = CJ_FLAT_ORDER[layout];
  if (!list) return 8888;
  const idx = list.indexOf(key);
  if (idx >= 0) return idx;
  return 3000;
};

/** CJ mockup: active row = full-width flat navy block, amber left bar, white label/icons */
const CJ_ACTIVE_ROW_BG = "#263E56";

const CustomTooltip = styled(({ className, ...props }) => {
  const { userType } = useUserType();
  const isDonationMode = userType === "donor";
  return <Tooltip {...props} classes={{ popper: className }} />;
})(({ theme }) => {
  const { userType } = useUserType();
  const isDonationMode = userType === "donor";
  return {
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: isDonationMode ? "#66D59A" : "var(--amber)",
      color: "#fff",
      fontSize: "16px",
      borderRadius: "4px",
      border: `2px solid ${isDonationMode ? "#66D59A" : "var(--amber)"}`,
    },
    [`& .MuiTooltip-arrow`]: {
      color: isDonationMode ? "#66D59A" : "var(--amber)",
    },
  };
});

const MyPopoverComponent = ({
  popoverOpen,
  togglePopover,
  handleNavigation,
  CompanyUrl = "",
  staffData = {},
}) => {
  const location = useLocation();
  const { userType } = useUserType();
  const isDonationMode = userType === "donor";

  const getCustomerPath = () => {
    let navigatePath = "";
    if (!location?.pathname?.includes("/staff-member")) {
      navigatePath = isDonationMode
        ? ["/index", "/donor"]
        : ["/index", "/add-customer"];
    } else {
      navigatePath = isDonationMode
        ? ["/index", "/staff-member", "/donor"]
        : ["/index", "/staff-member", "/add-customer"];
    }
    if (isDonationMode) {
      return {
        path: !location?.pathname?.includes("/staff-member")
          ? `/${CompanyUrl}/donor`
          : "/staff-member/add-customer",
        navigats: navigatePath,
      };
    }
    return {
      path: !location?.pathname?.includes("/staff-member")
        ? `/${CompanyUrl}/add-customer`
        : "/staff-member/add-customer",
      navigats: navigatePath,
    };
  };

  return (
    <UncontrolledPopover
      placement="right"
      target="PopoverLegacy"
      trigger="legacy"
      isOpen={popoverOpen}
      toggle={togglePopover}
      className={isDonationMode ? "donor-mode" : "regular-mode"}
    >
      <PopoverBody className="d-flex">
        {(!location?.pathname?.includes("/staff-member") ||
          staffData?.CustomersProperties?.ViewCreateAndEdit ||
          staffData?.CustomersProperties?.ViewCreateEditAndDelete) && (
          <Grid
            className="d-flex"
            style={{
              flexDirection: "column",
              borderRight: `2px solid ${
                isDonationMode ? "#29B3E2" : "var(--amber)"
              }`,
              paddingRight: "10px",
              cursor: "pointer",
            }}
            onClick={() => {
              const { path, navigats } = getCustomerPath();
              handleNavigation(path, { state: { navigats } });
            }}
          >
            <img
              src={isDonationMode ? DonorCustomer : Client2}
              style={{ height: "20px" }}
            />
            <Typography
              className={`my-1 ${
                isDonationMode ? "text-donor-color" : "text-orange-color"
              }`}
            >
              {isDonationMode && !location?.pathname?.includes("/staff-member")
                ? "Donor"
                : "Customer"}
            </Typography>
          </Grid>
        )}

        {!isDonationMode && (
          <>
            {(!location?.pathname?.includes("/staff-member") ||
              staffData?.Quotes?.ViewCreateAndEdit ||
              staffData?.Quotes?.ViewCreateEditAndDelete) && (
              <Grid
                className="d-flex mx-2"
                style={{
                  flexDirection: "column",
                  borderRight: "2px solid var(--amber)",
                  cursor: "pointer",
                  paddingRight: "10px",
                }}
                onClick={() =>
                  handleNavigation(
                    CompanyUrl
                      ? `/${CompanyUrl}/add-quotes`
                      : "/staff-member/add-quotes",
                    {
                      state: {
                        navigats: [
                          "/index",
                          CompanyUrl ? "/add-quotes" : "/add-quotes",
                        ],
                      },
                    }
                  )
                }
              >
                <img
                  src={Quote2 || "/placeholder.svg"}
                  style={{ height: "20px" }}
                />
                <Typography className="my-1 text-orange-color">
                  Quote
                </Typography>
              </Grid>
            )}

            {(!location?.pathname?.includes("/staff-member") ||
              staffData?.ServiceRequests?.ViewCreateAndEdit ||
              staffData?.ServiceRequests?.ViewCreateEditAndDelete) && (
              <Grid
                className="d-flex mx-2"
                style={{
                  flexDirection: "column",
                  borderRight: "2px solid var(--amber)",
                  cursor: "pointer",
                  paddingRight: "10px",
                }}
                onClick={() =>
                  handleNavigation(
                    CompanyUrl
                      ? !location?.pathname?.includes("/staff-member")
                        ? `/${CompanyUrl}/add-service-requests`
                        : `/${CompanyUrl}/staff-member/add-service-requests`
                      : "/staff-member/add-service-requests",
                    {
                      state: {
                        navigats: !location?.pathname?.includes("/staff-member")
                          ? ["/index", "/service-requests", "/add-service-requests"]
                          : [
                              "/index",
                              "/staff-member",
                              "/worker-service-requests",
                              "/add-service-requests",
                            ],
                      },
                    }
                  )
                }
              >
                <StickyNote2OutlinedIcon sx={{ fontSize: 20, color: "var(--amber)" }} />
                <Typography className="my-1 text-orange-color">Request</Typography>
              </Grid>
            )}

            {((!location?.pathname?.includes("/staff-member") && CompanyUrl) ||
              staffData?.Jobs?.JViewCreateAndEdit ||
              staffData?.Jobs?.JViewCreateEditAndDelete) && (
              <Grid
                className="d-flex"
                style={{
                  flexDirection: "column",
                  borderRight: "2px solid var(--amber)",
                  paddingRight: "10px",
                  cursor: "pointer",
                }}
                onClick={() =>
                  handleNavigation(
                    CompanyUrl
                      ? `/${CompanyUrl}/add-contract`
                      : "/staff-member/add-contract",
                    {
                      state: {
                        navigats: [
                          "/index",
                          CompanyUrl ? "/add-contract" : "/add-contract",
                        ],
                      },
                    }
                  )
                }
              >
                <img
                  src={Contract2 || "/placeholder.svg"}
                  style={{ height: "20px" }}
                />
                <Typography className="my-1 text-orange-color">
                  Contract
                </Typography>
              </Grid>
            )}
          </>
        )}

        {!isDonationMode && (!location?.pathname?.includes("/staff-member") ||
          staffData?.Invoice?.ViewAndEditFullClientAndPropertyInfo ||
          staffData?.Invoice?.ViewEditAndDeleteFullClientAndPropertyInfo) && (
          <Grid
            className="d-flex mx-2"
            style={{
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={() =>
              handleNavigation(
                !location?.pathname?.includes("/staff-member")
                  ? `/${CompanyUrl}/addinvoice`
                  : CompanyUrl
                  ? `/${CompanyUrl}/staff-member/addinvoice`
                  : "/staff-member/addinvoice",
                {
                  state: {
                    navigats: !location?.pathname?.includes("/staff-member")
                      ? ["/index", "/invoice", "/addinvoice"]
                      : ["/index", "/worker-invoice", "/addinvoice"],
                  },
                }
              )
            }
          >
            <img
              src={Invoiceorange}
              style={{ height: "20px" }}
            />
            <Typography
              className="my-1 text-orange-color"
            >
              Invoice
            </Typography>
          </Grid>
        )}
      </PopoverBody>
    </UncontrolledPopover>
  );
};

const Sidebar = ({
  layout,
  isSidebarClosed,
  setIsSidebarClosed,
  isSidebarDisplay,
  setIsSidebarDisplay,
  routesData,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { CompanyUrl } = useParams();
  const isMediumScreen = useMediaQuery("(max-width:767px)");
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [themeData, setthemeData] = useState("");
  const [tokenDecode, setTokenDecode] = useState({});
  const [currentLogoPath, setCurrentLogoPath] = useState("");
  const [logoUpdateTimestamp, setLogoUpdateTimestamp] = useState(Date.now().toString());
  const [isLogoLoaded, setIsLogoLoaded] = useState(false);
  const [isEmergencyMode, setIsEmergencyMode] = useState(false);
  const [isImpersonated, setIsImpersonated] = useState(() => {
    return getItem("isImpersonated") === "true";
  });
  const { userType } = useUserType();
  const isDonationMode = userType === "donor";
  const useCjRedesign =
    !isDonationMode &&
    [
      "/:CompanyUrl",
      "/:CompanyUrl/staff-member",
      "/:CompanyUrl/customers",
      "/superadmin",
    ].includes(layout);
  const cdnUrl = import.meta.env.VITE_BASE_API;
  
  // Construct uploads URL using the correct CDN endpoint
  // Use /v1/cdn/upload/ instead of /api/uploads/ to avoid 404 errors
  const uploadsUrl = cdnUrl.endsWith('/') 
    ? `${cdnUrl}v1/cdn/upload` 
    : `${cdnUrl}/v1/cdn/upload`;
  const fetchDatas = async (retryCount = 0) => {
    const maxRetries = 3;
    const retryDelay = 1000; // 1 second

    try {
      const res = await handleAuth(navigate, location);
      
      setTokenDecode(res?.data);
      setthemeData(res?.themes);
      const newLogoPath = res?.logo?.LogoPath || "";
      
      setCurrentLogoPath(newLogoPath);
      
      if (newLogoPath) {
        // Update timestamp to ensure fresh image load
        const timestamp = Date.now().toString();
        setLogoUpdateTimestamp(timestamp);
      }
      
      setIsLogoLoaded(true);
    } catch (error) {
      // Retry logic for 502 errors
      if (error?.response?.status === 502 && retryCount < maxRetries) {
        setTimeout(() => {
          fetchDatas(retryCount + 1);
        }, retryDelay * (retryCount + 1)); // Exponential backoff
        return;
      }
      
      // On error, clear logo path
      setCurrentLogoPath("");
      setIsLogoLoaded(true);
    }
  };

  // Listen for changes to isImpersonated in storage
  useEffect(() => {
    const checkImpersonation = () => {
      setIsImpersonated(getItem("isImpersonated") === "true");
    };
    
    checkImpersonation();
    // Note: storage event only fires for cross-tab changes, not same-tab changes
    // For sessionStorage, we need to check periodically since it's tab-specific
    window.addEventListener("storage", checkImpersonation);
    
    // Also check periodically in case storage is updated in same window
    const interval = setInterval(checkImpersonation, 1000);
    
    return () => {
      window.removeEventListener("storage", checkImpersonation);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    fetchDatas();
    
    // Listen for logo update events
    const handleLogoUpdate = (event) => {
      const { logoPath, hasDefaultLogo, isUpload, isDelete, isReset, databaseSaveSuccess } = event.detail;
      
      // Update state immediately for better UX
      const newLogoPath = logoPath || "";
      
      // Always update timestamp when logo changes to force browser cache refresh
      const timestamp = Date.now().toString();
      
      setLogoUpdateTimestamp(timestamp);
      setCurrentLogoPath(newLogoPath);
      
      // Force re-render by updating isLogoLoaded
      // Always toggle to ensure image reload, especially when logo path changes
      setIsLogoLoaded(false);
      setTimeout(() => {
        setIsLogoLoaded(true);
      }, 50);
      
      // If logo was updated, refetch from API to get latest data
      if (isUpload || isDelete || isReset) {
        setTimeout(() => {
          fetchDatas();
        }, 500);
      }
    };

    window.addEventListener('logoUpdated', handleLogoUpdate);

    // Cleanup event listener
    return () => {
      window.removeEventListener('logoUpdated', handleLogoUpdate);
    };
  }, []);

  useEffect(() => {
    const updateColors = () => {
      if (themeData && themeData) {
        const Colors = themeData?.Colors;
        for (const key in Colors) {
          if (Object.prototype.hasOwnProperty.call(Colors, key)) {
            const element = Colors[key];
            document.documentElement.style.setProperty(key, element);
          }
        }
      }
    };
    updateColors();
  }, [themeData]);

  const toggleSidebar = () => {
    setIsSidebarClosed(!isSidebarClosed);
  };

  // Phase 8 (JOB-3314): per-group drawer state. Keyed by group name (e.g.
  // "Email", "Engagement") so multiple inline-collapse groups coexist
  // without sharing open/closed state. Backward-compat aliases below
  // keep the existing email-specific call-sites working unchanged.
  const [inlineMenusOpen, setInlineMenusOpen] = useState({});
  const isInlineMenuOpen = (name) => !!inlineMenusOpen[name];
  const setInlineMenuOpen = (name, value) =>
    setInlineMenusOpen((prev) => {
      const cur = !!prev[name];
      const next = typeof value === "function" ? value(cur) : value;
      if (next === cur) return prev;
      return { ...prev, [name]: next };
    });
  const toggleInlineMenu = (name) => setInlineMenuOpen(name, (o) => !o);
  const closeAllInlineMenus = () => setInlineMenusOpen({});
  const isAnyInlineMenuOpen = () =>
    Object.values(inlineMenusOpen).some(Boolean);

  // Backward-compat — Email-specific aliases. Other code paths may still
  // reference these directly; keep them working.
  const emailMenuOpen = isInlineMenuOpen("Email");
  const setEmailMenuOpen = (v) => setInlineMenuOpen("Email", v);
  const emailMenuToggle = () => toggleInlineMenu("Email");

  useEffect(() => {
    if (!useCjRedesign) return;
    if (layout !== "/:CompanyUrl" || !CompanyUrl) {
      closeAllInlineMenus();
      return;
    }
    // For each inline group, auto-open when current URL is under one of
    // its children, auto-close otherwise. Adding a new inline group means
    // adding a name + checker here.
    const checkers = {
      Email: isEmailNavChildPathActive,
      Engagement: isEngagementNavChildPathActive,
    };
    setInlineMenusOpen((prev) => {
      const next = { ...prev };
      let changed = false;
      for (const name of CJ_INLINE_GROUPS) {
        const checker = checkers[name];
        if (!checker) continue;
        const want = checker(location.pathname, CompanyUrl);
        const has = !!prev[name];
        if (want !== has) {
          next[name] = want;
          changed = true;
        }
      }
      return changed ? next : prev;
    });
  }, [location.pathname, CompanyUrl, layout, useCjRedesign]);

  const togglePopover = () => setPopoverOpen(!popoverOpen);
  const closePopover = () => setPopoverOpen(false);

  // Note: Dropdown will not auto-open when child route is active
  // User must manually click to open/close the dropdown
  // Parent menu will still be highlighted when child is active

  const isMenuItemActive = (prop, currentProp) => {
    // Exact path matching for superadmin routes to prevent conflicts
    if (layout === "/superadmin") {
      // For collapse menus without a path (like Company Info), check children first
      if (prop?.isCollapse && prop?.children && !prop?.path) {
        const isSuperadminCollapseParentActive = prop.children.some(child => {
          const childFullPath = `${layout}${child.path}`;
          const isExactMatch = location?.pathname === childFullPath;
          const isPathMatch = location?.pathname?.includes(child.path);
          return isExactMatch || isPathMatch;
        });
        if (isSuperadminCollapseParentActive) {
          return true;
        }
      }
      
      const fullPath = prop?.path ? `${layout}${prop.path}` : null;
      const exactPathMatch = fullPath ? location?.pathname === fullPath : false;
      
      // Check for parent-child relationships in superadmin
      const superadminParentChildMap = {
        "/permission": ["/permission", "/add-permission"],
        "/company": ["/company", "/company-detail"],
      };
      
      let isSuperadminParentActive = false;
      if (prop?.path && superadminParentChildMap[prop.path]) {
        isSuperadminParentActive = superadminParentChildMap[prop.path].some(childPath => 
          location?.pathname?.includes(childPath)
        );
      }
      
      // For collapse menus (like Company Info with industry/revenue/team-size children)
      let isSuperadminCollapseParentActive = false;
      if (prop?.isCollapse && prop?.children) {
        isSuperadminCollapseParentActive = prop.children.some(child => {
          const childFullPath = `${layout}${child.path}`;
          const isExactMatch = location?.pathname === childFullPath;
          const isPathMatch = location?.pathname?.includes(child.path);
          return isExactMatch || isPathMatch;
        });
      }
      
      // If we have a currentProp from route matching, use that for exact match
      if (currentProp) {
        const currentFullPath = `${currentProp.layout}${currentProp.path}`;
        const currentPathMatch = location?.pathname === currentFullPath;
        
        // Check for exact match
        if (currentPathMatch && currentProp.path === prop.path && currentProp.layout === prop.layout) {
          return true;
        }
        
        // Check for module matching (e.g., company-detail belongs to Company module)
        if (currentProp.module && prop.module && currentProp.module === prop.module) {
          // If modules match, check if current path is a child of this prop
          if (isSuperadminParentActive) {
            return true;
          }
        }
      }
      
      // Check parent-child relationship, collapse parent, or exact path match
      return isSuperadminParentActive || isSuperadminCollapseParentActive || exactPathMatch;
    }
    
    // For other layouts, use exact match first, then includes for nested routes
    const basePath = prop?.layout?.replace(":CompanyUrl", CompanyUrl || "");
    const fullPath = `${basePath}${prop?.path}`;
    const exactMatch = location?.pathname === fullPath;
    
    // Check for parent-child relationships
    const parentChildMap = {
      "/customer": ["/add-customer", "/customer", "/customer-details", "/property-details"],
      "/donor": ["/donor", "/add-donor", "/add-donors", "/donor-property-details"],
      "/service-requests": ["/service-requests", "/service-request-detail", "/add-service-requests"],
      "/customer-service-requests": [
        "/customer-service-requests",
        "/customer-service-request-detail",
      ],
      "/quotes": ["/add-quotes", "/quotes", "/quotes-details"],
      "/contract": ["/add-contract", "/contract", "/contract-details"],
      "/invoice": ["/invoice", "/addinvoice", "/invoicetable", "/invoice-details", "/invoice-payment"],
      "/employee-hours": ["/employee-hours"],
      "/worker-invoice": ["/worker-invoice", "/addinvoice", "/workerinvoicetable", "/worker-invoice-detail", "/invoice-payment"],
      "/worker-customer": ["/add-customer", "/worker-customer", "/customer-details", "/worker-property-details"],
      "/worker-service-requests": [
        "/worker-service-requests",
        "/worker-service-request-detail",
        "/add-service-requests",
      ],
      "/worker-quote": ["/add-quotes", "/worker-quote", "/worker-quotes-details"],
      "/worker-contract": ["/add-contract", "/worker-contract", "/worker-contract-details"],
      // Do not list /worker-todays-appointments here — it is a separate MAIN nav item
      // ("Today's Appointments"). Listing it made OPERATIONS "Appointment" stay active on that URL.
      "/worker-appointments": ["/worker-appointments", "/appointment-confirm"],
      "/worker-time-entry": ["/worker-time-entry"],
      "/manageteam": ["/manageteam", "/add-user", "/worker-details"],
      "/company": ["/company", "/company-detail", "/superadmin/company", "/superadmin/company-detail"],
      "/company-reports": ["/company-reports", "/labor-hours-report", "/transaction-history", "/failed-transaction-history", "/recurring-payment-report", "/failed-recurring-payment-report", "/transaction-batch-report"],
      "/reports": ["/reports", "/donation-summary", "/executive-summary", "/transaction-report", "/failed-transaction-report", "/retention-report", "/major-gifts", "/recurring-donors"],
      "/templates": ["/templates", "/add-templates", "/add-new-email"],
      "/accept-donation": ["/accept-donation"],
    };
    
    // Check if current path matches this prop's children
    let isParentActive = false;
    if (parentChildMap[prop?.path]) {
      const currentPath = location?.pathname || '';
      isParentActive = parentChildMap[prop?.path].some(childPath => {
        // Check exact match first, then includes
        if (currentPath === childPath) return true;
        // For paths like /superadmin/company-detail, check if it includes the child path
        if (currentPath.includes(childPath)) return true;
        // Also check if childPath is a substring (for cases like /company-detail matching /superadmin/company-detail)
        if (childPath.includes('/company-detail') && currentPath.includes('company-detail')) return true;
        if (childPath.includes('/company') && currentPath.includes('company-detail')) return true;
        // Special handling for worker-quotes-details (e.g., /keybrainstech/staff-member/worker-quotes-details)
        if (childPath === '/worker-quotes-details' && currentPath.includes('worker-quotes-details')) return true;
        if (childPath === '/worker-service-request-detail' && currentPath.includes('worker-service-request-detail'))
          return true;
        if (
          childPath === '/customer-service-request-detail' &&
          currentPath.includes('customer-service-request-detail')
        )
          return true;
        // Special handling for customer-details (e.g., /keybrainstech/staff-member/customer-details)
        if (childPath === '/customer-details' && currentPath.includes('customer-details')) return true;
        // Special handling for appointment-confirm (e.g., /keybrainstech/staff-member/appointment-confirm)
        if (childPath === '/appointment-confirm' && currentPath.includes('appointment-confirm')) return true;
        // Special handling for worker-details (e.g., /keybrainstech/worker-details)
        if (childPath === '/worker-details' && currentPath.includes('worker-details')) return true;
        // Special handling for add-user (e.g., /keybrainstech/add-user)
        if (childPath === '/add-user' && currentPath.includes('add-user')) return true;
        return false;
      });
    }
    
    // For collapse menus (like Email with templates/Email-logs children)
    let isCollapseParentActive = false;
    if (prop?.isCollapse && prop?.children) {
      isCollapseParentActive = prop.children.some(child => {
        // Check for exact match and related paths (e.g., /templates and /add-templates)
        const childPath = child.path;
        const isMatch = location?.pathname?.includes(childPath);
        
        // Special handling for templates - also activate on /add-templates and /add-new-email
        if (childPath === "/templates" && (location?.pathname?.includes("/add-templates") || location?.pathname?.includes("/add-new-email"))) {
          return true;
        }
        
        // Special handling for email-campaign - also activate on /add-email-campaign and /email-campaign-details
        if (childPath === "/email-campaign" && (location?.pathname?.includes("/add-email-campaign") || location?.pathname?.includes("/email-campaign-details"))) {
          return true;
        }
        
        return isMatch;
      });
    }
    
    // For nested routes, use includes but be careful with similar paths
    const pathMatch = exactMatch || location?.pathname?.includes(prop?.path) || isParentActive || isCollapseParentActive;

    // Use currentProp if available for more accurate matching
    if (currentProp) {
      const moduleMatch = currentProp?.module === prop?.module && prop?.module;
      // Flexible module matching for variations like "Quote" vs "Quotes"
      const flexibleModuleMatch = prop?.module && currentProp?.module && 
        (currentProp.module.toLowerCase() === prop.module.toLowerCase() ||
         currentProp.module.toLowerCase().includes(prop.module.toLowerCase()) ||
         prop.module.toLowerCase().includes(currentProp.module.toLowerCase()));
      const nameMatch = currentProp?.name === prop?.name;
      
      // If parent is active (e.g., worker-quotes-details belongs to worker-quote), prioritize that
      // This handles cases where module names differ slightly (e.g., "Quote" vs "Quotes")
      if (isParentActive && (moduleMatch || flexibleModuleMatch || pathMatch)) {
        return true;
      }
      
      return (exactMatch || pathMatch) && (moduleMatch || flexibleModuleMatch || nameMatch || exactMatch);
    }

    return pathMatch;
  };

  const createLinks = (props) => {
    const matchPath = (path, layout, CompanyUrl) => {
      const basePath = layout?.replace(":CompanyUrl", CompanyUrl);
      return `${location?.pathname}` === `${basePath}${path}`;
    };

    const findMatchingRoute = (routes, layout, CompanyUrl) => {
      for (const route of routes) {
        if (!route.isCollapse && matchPath(route.path, layout, CompanyUrl)) {
          return route;
        }

        if (route.children) {
          const matchingChild = route.children.find((child) => {
            return matchPath(child.path, child.layout, CompanyUrl);
          });

          if (matchingChild) {
            return matchingChild;
          }
        }
      }
      return null;
    };

    const currentProp = findMatchingRoute(routes, layout, CompanyUrl);

    const filteredProps = props?.filter((prop) => {
      if (prop.layout?.includes("/staff-member")) {
        return true;
      }

      // Show Manage Team only for Company Owners
      if (prop.path === "/manageteam" || prop.name === "Manage Team") {
        return getAuthProfile(tokenDecode)?.Role === "Company" && !isDonationMode;
      }

      if (isDonationMode) {
        if (
          prop.name === "Quotes" ||
          prop.name === "Contracts" ||
          prop.name === "Invoice" ||
          prop.name === "Worker Hours" ||
          prop.name === "Schedule" ||
          prop.name === "Today's Appointments" ||
          prop.name === "POS" ||
          prop.name === "Materials & Labor" ||
          prop.path?.includes("/quotes") ||
          prop.path?.includes("/service-requests") ||
          prop.path?.includes("/customer-service-requests") ||
          prop.path?.includes("/worker-service") ||
          prop.path?.includes("/contract") ||
          prop.path?.includes("/invoice") ||
          prop.path?.includes("/schedule") ||
          prop.path === "/todays-appointments" ||
          (prop.path?.includes("/pos") && prop.name !== "Accept Donation") ||
          prop.path?.includes("/materials-labor") ||
          prop.path?.includes("/materials-labor")
        ) {
          return false;
        }

        if (prop.path === "/customer") {
          return false;
        }
        if (prop.path === "/donor") {
          return true;
        }
        if (prop.path === "/company-reports") {
          return false;
        }
        // Show "Accept Donation" in donation mode
        if (prop.name === "Accept Donation") {
          return true;
        }
      } else {
        if (prop.path === "/donor") {
          return false;
        }
        if (prop.path === "/reports") {
          return false;
        }
        if (prop.path === "/company-reports") {
          return true;
        }
        // Hide "Accept Donation" in non-donation mode
        if (prop.name === "Accept Donation") {
          return false;
        }


      }

      if (prop.path === "/service-requests") {
        return getAuthProfile(tokenDecode)?.Role === "Company" && !isDonationMode;
      }
      if (prop.path === "/customer-service-requests") {
        return getAuthProfile(tokenDecode)?.Role === "Customer" && !isDonationMode;
      }

      return true;
    });

    const getCrmNavBadge = (prop) => {
      if (!useCjRedesign || !navCounts || isSidebarClosed) return null;
      const p = prop.path;
      if (layout === "/:CompanyUrl") {
        if (p === "/customer")
          return { n: navCounts.Customer, variant: "muted" };
        if (p === "/service-requests")
          return { n: navCounts.serviceRequests, variant: "muted" };
        if (p === "/quotes")
          return { n: navCounts.quotes, variant: "muted" };
        if (p === "/contract")
          return { n: navCounts.contracts, variant: "muted" };
        if (p === "/invoice")
          return { n: navCounts.invoices, variant: "muted" };
      }
      if (layout === "/:CompanyUrl/staff-member") {
        if (p === "/worker-customer")
          return { n: navCounts.Customer, variant: "muted" };
        if (p === "/worker-service-requests")
          return { n: navCounts.serviceRequests, variant: "muted" };
        if (p === "/worker-quote")
          return { n: navCounts.quotes, variant: "muted" };
        if (p === "/worker-contract")
          return { n: navCounts.contracts, variant: "muted" };
        if (p === "/worker-invoice")
          return { n: navCounts.invoices, variant: "muted" };
      }
      if (layout === "/:CompanyUrl/customers") {
        if (p === "/customer-service-requests")
          return { n: navCounts.serviceRequests, variant: "muted" };
        if (p === "/quotes")
          return { n: navCounts.quotes, variant: "muted" };
        if (p === "/contract")
          return { n: navCounts.contracts, variant: "muted" };
        if (p === "/invoice")
          return { n: navCounts.invoices, variant: "muted" };
      }
      return null;
    };

    const renderNavBadge = (prop) => {
      const b = getCrmNavBadge(prop);
      if (b == null || b.n == null) return null;
      const num = Number(b.n);
      if (Number.isNaN(num)) return null;
      const label = String(num);
      const isDanger = b.variant === "danger";
      return (
        <span
          className="cj-sidebar-nav-badge"
          style={{
            marginLeft: "auto",
            flexShrink: 0,
            minWidth: 22,
            height: 22,
            padding: "0 7px",
            borderRadius: 999,
            background: isDanger ? "#DC2626" : "rgba(255,255,255,0.22)",
            color: "#fff",
            fontSize: 11,
            fontWeight: 700,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            lineHeight: 1,
          }}
        >
          {label}
        </span>
      );
    };

    const sortedForCj = useCjRedesign
      ? [...filteredProps]
          .map((p, idx) => ({ p, idx }))
          .sort((a, b) => {
            if (a.p.layout !== layout && b.p.layout !== layout)
              return a.idx - b.idx;
            if (a.p.layout !== layout) return 1;
            if (b.p.layout !== layout) return -1;
            const oa = getCjFlatOrder(a.p, layout);
            const ob = getCjFlatOrder(b.p, layout);
            if (oa !== ob) return oa - ob;
            return a.idx - b.idx;
          })
          .map(({ p }) => p)
      : filteredProps;

    let lastCjSection = null;
    let cjSectionHeaderIndex = 0;
    return sortedForCj?.map((prop, index) => {
      // Phase 8 (JOB-3314): variable kept the historic "Email" name so the
      // ~16 downstream references didn't churn, but the underlying check
      // now matches any group in CJ_INLINE_GROUPS (currently Email +
      // Engagement). Per-prop drawer state is read via isInlineMenuOpen.
      const isCjEmailCollapse =
        useCjRedesign && CJ_INLINE_GROUPS.includes(prop.name) && prop.isCollapse;
      const propMenuOpen = isCjEmailCollapse && isInlineMenuOpen(prop.name);
      const isActiveRaw = isMenuItemActive(prop, currentProp);
      const suppressOtherNavActiveForEmailDrawer =
        useCjRedesign &&
        layout === "/:CompanyUrl" &&
        isAnyInlineMenuOpen() &&
        !isCjEmailCollapse;
      const isActive = suppressOtherNavActiveForEmailDrawer
        ? false
        : isActiveRaw;
      const emailChildPathActive =
        isCjEmailCollapse &&
        CompanyUrl &&
        isInlineGroupChildPathActive(prop, location.pathname, CompanyUrl);
      const showCjEmailSubnav = propMenuOpen;
      const emailParentLooksActive =
        isCjEmailCollapse && propMenuOpen && !emailChildPathActive;
      const shouldShowLeftArrow = isActive || (isCjEmailCollapse && propMenuOpen);
      const cjNavIconEl =
        useCjRedesign && !isDonationMode
          ? getCjNavMuiIcon(prop, layout)
          : null;
      const cjSection = useCjRedesign ? getCjNavSection(prop, layout) : null;
      const showCjSectionHeader =
        useCjRedesign &&
        cjSection &&
        cjSection !== lastCjSection &&
        !isSidebarClosed;
      if (cjSection) lastCjSection = cjSection;

      return (
        <Fragment key={index}>
          {showCjSectionHeader && (
            <Typography
              className="cj-sidebar-section-label"
              sx={{
                display: "block",
                paddingLeft: "18px",
                paddingRight: "10px",
                marginTop: cjSectionHeaderIndex++ === 0 ? "8px" : "24px",
                marginBottom: "10px",
                fontSize: "11px",
                fontWeight: 600,
                letterSpacing: "0.12em",
                color: "#6B7280",
                textTransform: "uppercase",
              }}
            >
              {cjSection}
            </Typography>
          )}
        <Grid>
          {prop.layout === layout && prop.isCollapse && prop.isDisplay ? (
            !isSidebarClosed ? (
              <Grid
                className={`d-flex align-items-center sidebar-email-row${
                  isCjEmailCollapse ? " cj-email-flat" : ""
                }`}
                sx={
                  useCjRedesign && !isSidebarClosed
                    ? {
                        marginLeft: "0",
                        marginRight: "0",
                        marginBottom: "12px",
                      }
                    : undefined
                }
              >
                <Typography
                  component="div"
                  className="sidebar-collapse-arrow-slot"
                  sx={{
                    width: "auto",
                    paddingLeft: 0,
                    marginLeft: 0,
                    display: !isSidebarClosed
                      ? isCjEmailCollapse
                        ? "none"
                        : "flex"
                      : "none",
                    alignItems: "center",
                    justifyContent: "center",
                    alignSelf: "stretch",
                    minHeight: 48,
                    minWidth: 35,
                    flexShrink: 0,
                  }}
                >
                  <ArrowRightOutlinedIcon
                    style={{
                      fontSize: "35px",
                      color: shouldShowLeftArrow
                        ? isDonationMode
                          ? "#66D59A"
                          : "#fff"
                        : "transparent",
                    }}
                  />
                </Typography>
                {isCjEmailCollapse ? (
                  <Box
                    className="sideBarEmailLeft cj-email-inline-nav"
                    sx={{
                      flex: 1,
                      minWidth: 0,
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Box
                      component="button"
                      type="button"
                      onClick={() => toggleInlineMenu(prop.name)}
                      className={`sidebar-collapse-toggle sidebar-email-toggle${
                        useCjRedesign &&
                        !isDonationMode &&
                        emailParentLooksActive
                          ? " cj-sidebar-email-toggle--active"
                          : ""
                      }`}
                      sx={{
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                        width: "100%",
                        maxWidth: "100%",
                        minHeight: 44,
                        textAlign: "left",
                        paddingLeft: "12px",
                        paddingRight: "12px",
                        paddingTop: "10px",
                        paddingBottom: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                        cursor: "pointer",
                        color: "#fff",
                        borderRadius: 0,
                        background:
                          !isSidebarClosed && emailParentLooksActive
                            ? CJ_ACTIVE_ROW_BG
                            : "transparent",
                      }}
                    >
                      <span
                        className="sidebar-email-icon-wrap"
                        style={{
                          display: "inline-flex",
                          flexShrink: 0,
                          alignItems: "center",
                          justifyContent: "center",
                          width: 44,
                          minWidth: 44,
                          maxWidth: 44,
                          height: 22,
                        }}
                      >
                        {cjNavIconEl ?? prop.icon}
                      </span>
                      <Typography
                        className="text nav-text"
                        component="span"
                        sx={{
                          flex: 1,
                          minWidth: 0,
                          lineHeight: 1.2,
                          fontWeight: emailParentLooksActive ? 600 : 400,
                          color: "#fff",
                        }}
                      >
                        {prop?.name}
                      </Typography>
                      <ExpandMoreIcon
                        sx={{
                          flexShrink: 0,
                          color: "rgba(255,255,255,0.85)",
                          fontSize: 22,
                          transition: "transform 0.2s ease",
                          transform: showCjEmailSubnav
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        }}
                      />
                    </Box>
                    <Collapse in={showCjEmailSubnav} timeout="auto" unmountOnExit>
                      <List
                        dense
                        disablePadding
                        className="cj-email-inline-subnav"
                        sx={{ pt: 0.5, pb: 0.5 }}
                      >
                        {prop.children?.map((item, idx) => {
                          let isChildActive = location.pathname.includes(
                            item.path
                          );
                          if (
                            item.path === "/templates" &&
                            (location?.pathname?.includes("/add-templates") ||
                              location?.pathname?.includes("/add-new-email"))
                          ) {
                            isChildActive = true;
                          }
                          if (
                            item.path === "/email-campaign" &&
                            (location?.pathname?.includes(
                              "/add-email-campaign"
                            ) ||
                              location?.pathname?.includes(
                                "/email-campaign-details"
                              ))
                          ) {
                            isChildActive = true;
                          }
                          return (
                            <ListItemButton
                              key={idx}
                              className="cj-email-inline-subnav__item"
                              onClick={() => {
                                let path = prop.layout.replace(
                                  ":CompanyUrl",
                                  CompanyUrl
                                );
                                if (isMediumScreen) {
                                  setIsSidebarDisplay(!isSidebarDisplay);
                                }
                                // Keep this group's drawer open after navigation.
                                setInlineMenuOpen(prop.name, true);
                                navigate(path + item.path, {
                                  state: {
                                    navigats: item?.path?.includes("/index")
                                      ? ["/index"]
                                      : ["/index", item?.path],
                                    breadcrumbs: item?.path?.includes("/index")
                                      ? ["Home"]
                                      : ["Home", item?.name],
                                  },
                                });
                              }}
                              sx={{
                                pl: 1.75,
                                pr: 1,
                                py: 0.75,
                                borderRadius: 0,
                                borderLeft: isChildActive
                                  ? "3px solid #D4943A"
                                  : "3px solid transparent",
                                bgcolor: isChildActive
                                  ? "rgba(255,255,255,0.1)"
                                  : "transparent",
                                "&:hover": {
                                  bgcolor: "rgba(255,255,255,0.07)",
                                },
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  minWidth: 34,
                                  color: "#fff",
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 20,
                                    color: "#fff",
                                  },
                                  "& img": {
                                    maxHeight: 20,
                                    maxWidth: 20,
                                    opacity: isChildActive ? 1 : 0.8,
                                  },
                                }}
                              >
                                {item.icon}
                              </ListItemIcon>
                              <ListItemText
                                primary={item.name}
                                primaryTypographyProps={{
                                  fontSize: "0.8125rem",
                                  fontWeight: isChildActive ? 600 : 500,
                                  color: "#fff",
                                  noWrap: true,
                                }}
                              />
                            </ListItemButton>
                          );
                        })}
                      </List>
                    </Collapse>
                  </Box>
                ) : (
                  <Dropdown
                    className="sideBarEmailLeft"
                    style={{
                      backgroundColor: "transparent",
                      border: "none",
                      boxShadow: "none",
                      justifyContent: "start",
                      marginLeft: 0,
                      flex: 1,
                      minWidth: 0,
                    }}
                    isOpen={emailMenuOpen}
                    toggle={emailMenuToggle}
                  >
                    <DropdownToggle
                      caret={false}
                      className={`sidebar-collapse-toggle sidebar-email-toggle ${
                        isDonationMode ? "donor-mode-toggle" : ""
                      }${
                        useCjRedesign &&
                        !isDonationMode &&
                        isCjEmailCollapse &&
                        shouldShowLeftArrow
                          ? " cj-sidebar-email-toggle--active"
                          : ""
                      }`}
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                        width: "100%",
                        maxWidth: "100%",
                        minHeight: isCjEmailCollapse ? 44 : 48,
                        textAlign: "left",
                        paddingLeft:
                          isCjEmailCollapse && useCjRedesign
                            ? "12px"
                            : isCjEmailCollapse
                            ? "14px"
                            : "10px",
                        paddingRight: "12px",
                        paddingTop: isCjEmailCollapse ? 10 : 0,
                        paddingBottom: isCjEmailCollapse ? 10 : 0,
                        display: "flex",
                        alignItems: "center",
                        gap:
                          isCjEmailCollapse && useCjRedesign ? "16px" : "8px",
                        background:
                          !isSidebarClosed && shouldShowLeftArrow
                            ? isDonationMode
                              ? "#5BB5C9"
                              : useCjRedesign
                              ? CJ_ACTIVE_ROW_BG
                              : "#fff"
                            : "transparent",
                        color: "#fff",
                        borderTopLeftRadius: useCjRedesign ? "0" : "24px",
                        borderBottomLeftRadius: useCjRedesign ? "0" : "24px",
                        borderTopRightRadius: useCjRedesign ? "0" : "0",
                        borderBottomRightRadius: useCjRedesign ? "0" : "0",
                        borderLeft:
                          useCjRedesign &&
                          !isDonationMode &&
                          !isSidebarClosed &&
                          shouldShowLeftArrow &&
                          !isCjEmailCollapse
                            ? "3px solid #D4943A"
                            : "none",
                      }}
                    >
                      <span
                        className="sidebar-email-icon-wrap"
                        style={{
                          display: "inline-flex",
                          flexShrink: 0,
                          alignItems: "center",
                          justifyContent: "center",
                          width:
                            isCjEmailCollapse && useCjRedesign ? "44px" : "20%",
                          minWidth:
                            isCjEmailCollapse && useCjRedesign ? "44px" : 36,
                          maxWidth:
                            isCjEmailCollapse && useCjRedesign ? "44px" : 48,
                          height: 22,
                        }}
                      >
                        {cjNavIconEl ??
                          (isDonationMode
                            ? shouldShowLeftArrow
                              ? prop.icon
                              : prop.icon2
                            : !isSidebarClosed && shouldShowLeftArrow
                            ? useCjRedesign && !isDonationMode
                              ? prop.icon
                              : prop.icon2
                            : prop.icon)}
                      </span>
                      <Typography
                        className="text nav-text"
                        component="span"
                        style={{
                          paddingLeft: 0,
                          flex: 1,
                          minWidth: 0,
                          lineHeight: 1.2,
                          display: "flex",
                          alignItems: "center",
                          fontWeight:
                            useCjRedesign &&
                            !isDonationMode &&
                            isCjEmailCollapse &&
                            shouldShowLeftArrow
                              ? 600
                              : undefined,
                          color:
                            isDonationMode && shouldShowLeftArrow
                              ? "#fff"
                              : isDonationMode && !shouldShowLeftArrow
                              ? "#000"
                              : !isSidebarClosed && shouldShowLeftArrow
                              ? useCjRedesign
                                ? "#fff"
                                : "#0f2b46"
                              : "#fff",
                        }}
                      >
                        {prop?.name}
                      </Typography>
                    </DropdownToggle>

                    <DropdownMenu
                      style={{
                        padding: "0 0 0 5px",
                        margin: "0",
                        float: "right",
                      }}
                    >
                      {prop.children &&
                        prop.children?.map((item, index) => {
                          let isChildActive =
                            location.pathname.includes(item.path);

                          if (
                            item.path === "/templates" &&
                            (location?.pathname?.includes("/add-templates") ||
                              location?.pathname?.includes("/add-new-email"))
                          ) {
                            isChildActive = true;
                          }

                          if (
                            item.path === "/email-campaign" &&
                            (location?.pathname?.includes(
                              "/add-email-campaign"
                            ) ||
                              location?.pathname?.includes(
                                "/email-campaign-details"
                              ))
                          ) {
                            isChildActive = true;
                          }

                          return (
                            <DropdownItem
                              key={index}
                              style={{
                                padding: "0",
                                margin: "0",
                                width: "100%",
                                paddingRight: "25px",
                                paddingLeft: "0",
                                marginLeft: "0",
                              }}
                              onClick={(e) => {
                                let path = prop.layout;
                                path = path.replace(":CompanyUrl", CompanyUrl);

                                if (isMediumScreen) {
                                  setIsSidebarDisplay(!isSidebarDisplay);
                                }
                                e.stopPropagation();
                                setEmailMenuOpen(false);
                                navigate(path + item.path, {
                                  state: {
                                    navigats: item?.path?.includes("/index")
                                      ? ["/index"]
                                      : ["/index", item?.path],
                                    breadcrumbs: item?.path?.includes("/index")
                                      ? ["Home"]
                                      : ["Home", item?.name],
                                  },
                                });
                              }}
                            >
                              <li
                                style={{
                                  padding: "0",
                                  margin: "0",
                                  width: "100%",
                                  paddingLeft: "0",
                                  marginLeft: "0",
                                }}
                              >
                                <Typography
                                  style={{
                                    width: "auto",
                                    paddingLeft: "0",
                                    marginLeft: "0",
                                  }}
                                >
                                  <ArrowRightOutlinedIcon
                                    className={
                                      isChildActive && isDonationMode
                                        ? "text-donor-color"
                                        : ""
                                    }
                                    style={{
                                      fontSize: "30px",
                                      color:
                                        isChildActive && !isDonationMode
                                          ? "#0f2b46"
                                          : "#fff",
                                    }}
                                  />
                                </Typography>
                                <Typography
                                  className={
                                    isChildActive && isDonationMode
                                      ? "text-donor-color"
                                      : ""
                                  }
                                  style={{
                                    width: "10%",
                                    color:
                                      isChildActive && !isDonationMode
                                        ? "#0f2b46"
                                        : "#66D59A",
                                  }}
                                >
                                  {item.icon2}
                                </Typography>
                                <Typography
                                  className="text nav-text"
                                  style={{
                                    paddingLeft: "15px",
                                    color: isChildActive ? "#0f2b46" : "#0f2b46",
                                  }}
                                >
                                  {item.name}
                                </Typography>
                              </li>
                            </DropdownItem>
                          );
                        })}
                    </DropdownMenu>
                  </Dropdown>
                )}
              </Grid>
            ) : (
              <>
                {prop.layout === layout &&
                  prop.children?.map((item, index) => {
                    let isChildActive =
                      currentProp?.name === item?.name ||
                      location.pathname.includes(item.path);
                    
                    // Special handling for templates
                    if (item.path === "/templates" && (location?.pathname?.includes("/add-templates") || location?.pathname?.includes("/add-new-email"))) {
                      isChildActive = true;
                    }
                    
                    // Special handling for email-campaign
                    if (item.path === "/email-campaign" && (location?.pathname?.includes("/add-email-campaign") || location?.pathname?.includes("/email-campaign-details"))) {
                      isChildActive = true;
                    }

                    return (
                      <CustomTooltip
                        title={isSidebarClosed ? item?.name : ""}
                        arrow
                        placement="right"
                        key={index}
                      >
                        <li
                          onClick={() => {
                            let path = prop.layout;
                            path = path.replace(":CompanyUrl", CompanyUrl);

                            if (isMediumScreen) {
                              setIsSidebarDisplay(!isSidebarDisplay);
                            }

                            // Close dropdown after selecting a child item
                            setEmailMenuOpen(false);
                            navigate(path + item.path, {
                              state: {
                                navigats: item?.path?.includes("/index")
                                  ? ["/index"]
                                  : ["/index", item?.path],
                                breadcrumbs: item?.path?.includes("/index")
                                  ? ["Home"]
                                  : ["Home", item?.name],
                              },
                            });
                          }}
                          className="mb-3"
                          style={{
                            color: "#fff",
                            fontWeight: "400",
                            width: "100%",
                          }}
                        >
                          <Typography
                            style={{
                              background:
                                isSidebarClosed && isChildActive
                                  ? isDonationMode
                                    ? "#29B3E299"
                                    : "#fff"
                                  : "transparent",
                              marginLeft:
                                !isSidebarClosed && isChildActive
                                  ? "100px"
                                  : "19px",
                              width: "50px",
                              height: " 100%",
                              padding: "15px",
                              borderRadius: "12px",
                              justifyContent: "center",
                              display: "flex",
                            }}
                            className="side-icon-small"
                          >
                            {isDonationMode
                              ? isChildActive
                                ? item.icon
                                : item.icon2
                              : isSidebarClosed && isChildActive
                              ? item.icon2
                              : item.icon}
                          </Typography>
                        </li>
                      </CustomTooltip>
                    );
                  })}
              </>
            )
          ) : (
            prop.layout === layout &&
            prop.isDisplay && (
              <Grid style={{ display: "flex", alignItems: "center" }}>
                {!isSidebarClosed && (
                  <Typography
                    style={{ width: "auto" }}
                    className="Right-arrowww"
                  >
                    <ArrowRightOutlinedIcon
                      style={{
                        fontSize: "35px",
                        color:
                          isDonationMode && isActive
                            ? "#66D59A"
                            : isActive
                            ? "#fff"
                            : "transparent",
                      }}
                    />
                  </Typography>
                )}
                <CustomTooltip
                  title={isSidebarClosed ? prop?.name : ""}
                  arrow
                  placement="right"
                >
                  <li
                    onClick={(e) => {
                      let path = prop.layout;
                      path = path.replace(":CompanyUrl", CompanyUrl);

                      if (isMediumScreen) {
                        setIsSidebarDisplay(!isSidebarDisplay);
                      }
                      e.stopPropagation();
                      navigate(path + prop.path, {
                        state: {
                          navigats: prop.path.includes("/index")
                            ? ["/index"]
                            : ["/index", prop.path],
                          breadcrumbs: prop.path.includes("/index")
                            ? ["Home"]
                            : ["Home", prop.name],
                        },
                      });
                    }}
                    className={`mb-3${useCjRedesign && !isDonationMode && isActive ? " cj-sidebar-nav-item--active" : ""}`}
                    style={
                      useCjRedesign && !isDonationMode && !isSidebarClosed
                        ? {
                            color: "#fff",
                            fontWeight: isActive ? "600" : "400",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            boxSizing: "border-box",
                            marginLeft: "0",
                            marginRight: "0",
                            marginBottom: "12px",
                            borderRadius: "0",
                            padding: isActive
                              ? "12px 16px 12px 12px"
                              : "10px 16px 10px 12px",
                            background: isActive
                              ? CJ_ACTIVE_ROW_BG
                              : "transparent",
                            borderLeft: isActive
                              ? "3px solid #D4943A"
                              : "none",
                          }
                        : {
                            color: "#fff",
                            fontWeight: "400",
                            width: "100%",
                            display: useCjRedesign ? "flex" : undefined,
                            alignItems: useCjRedesign ? "center" : undefined,
                            boxSizing: "border-box",
                            background:
                              !isSidebarClosed && isActive
                                ? isDonationMode
                                  ? "#29B3E299"
                                  : useCjRedesign
                                  ? CJ_ACTIVE_ROW_BG
                                  : "#fff"
                                : "transparent",
                            borderTopLeftRadius: useCjRedesign ? "0" : "24px",
                            borderBottomLeftRadius: useCjRedesign
                              ? "0"
                              : "24px",
                            borderTopRightRadius: useCjRedesign
                              ? "0"
                              : undefined,
                            borderBottomRightRadius: useCjRedesign
                              ? "0"
                              : undefined,
                            paddingLeft:
                              !isSidebarClosed && useCjRedesign ? "10px" : "10px",
                            borderLeft:
                              useCjRedesign &&
                              !isDonationMode &&
                              !isSidebarClosed &&
                              isActive
                                ? "3px solid #D4943A"
                                : "none",
                          }
                    }
                  >
                    <Typography
                      className="d-flex justify-content-center mx-auto align-items-center"
                      style={{
                        width: isSidebarClosed
                          ? "50px"
                          : useCjRedesign
                          ? "44px"
                          : "20%",
                        minWidth: useCjRedesign && !isSidebarClosed ? "44px" : undefined,
                        maxWidth: useCjRedesign && !isSidebarClosed ? "44px" : undefined,
                        flexShrink: useCjRedesign ? 0 : undefined,
                        height: "100%",
                        padding: isSidebarClosed && "12px",
                        background:
                          isSidebarClosed && isActive
                            ? isDonationMode
                              ? "#29B3E299"
                              : useCjRedesign
                              ? CJ_ACTIVE_ROW_BG
                              : "#fff"
                            : "transparent",
                        borderRadius:
                          useCjRedesign && !isDonationMode ? "0" : "12px",
                      }}
                    >
                      {cjNavIconEl ??
                        (isDonationMode
                          ? isActive
                            ? prop.icon
                            : prop.icon2
                          : isActive
                          ? useCjRedesign && !isDonationMode
                            ? prop.icon
                            : prop.icon2
                          : prop.icon)}
                    </Typography>
                    {!isSidebarClosed &&
                      (useCjRedesign ? (
                        <div
                          style={{
                            flex: 1,
                            minWidth: 0,
                            display: "flex",
                            flexDirection: "row",
                            alignItems:
                              prop?.name === "Materials & Labor"
                                ? "flex-start"
                                : "center",
                            justifyContent: "space-between",
                            gap: 8,
                            paddingLeft: "16px",
                          }}
                        >
                          <Typography
                            className="text nav-text d-flex justify-content-start"
                            style={{
                              height: "100%",
                              maxWidth: "100%",
                              marginTop:
                                prop?.name === "Materials & Labor"
                                  ? useCjRedesign
                                    ? "4px"
                                    : "10px"
                                  : "0px",
                              flex: 1,
                              minWidth: 0,
                              color: isDonationMode
                                ? isActive
                                  ? "#fff"
                                  : "#000"
                                : isActive
                                ? useCjRedesign
                                  ? "#fff"
                                  : "#0f2b46"
                                : "#fff",
                              flexDirection:
                                prop?.name === "Materials & Labor"
                                  ? "column"
                                  : "row",
                              alignItems:
                                prop?.name === "Materials & Labor"
                                  ? "flex-start"
                                  : "center",
                              alignContent:
                                prop?.name === "Materials & Labor"
                                  ? "flex-start"
                                  : "center",
                            }}
                          >
                            {prop?.name === "Materials & Labor" ? (
                              <>
                                <span
                                  style={{ display: "block", lineHeight: "1.3" }}
                                >
                                  Materials &
                                </span>
                                <span
                                  style={{ display: "block", lineHeight: "1.3" }}
                                >
                                  Labor
                                </span>
                              </>
                            ) : (
                              prop?.name
                            )}
                          </Typography>
                          {renderNavBadge(prop)}
                        </div>
                      ) : (
                        <Typography
                          className="text nav-text d-flex justify-content-start"
                          style={{
                            paddingLeft: "15px",
                            height: "100%",
                            maxWidth: "100%",
                            marginTop:
                              prop?.name === "Materials & Labor" ? "10px" : "0px",
                            width: "100%",
                            color: isDonationMode
                              ? isActive
                                ? "#fff"
                                : "#000"
                              : isActive
                              ? "#0f2b46"
                              : "#fff",
                            flexDirection:
                              prop?.name === "Materials & Labor"
                                ? "column"
                                : "row",
                            alignItems:
                              prop?.name === "Materials & Labor"
                                ? "flex-start"
                                : "center",
                            alignContent:
                              prop?.name === "Materials & Labor"
                                ? "flex-start"
                                : "center",
                          }}
                        >
                          {prop?.name === "Materials & Labor" ? (
                            <>
                              <span
                                style={{ display: "block", lineHeight: "1.3" }}
                              >
                                Materials &
                              </span>
                              <span
                                style={{ display: "block", lineHeight: "1.3" }}
                              >
                                Labor
                              </span>
                            </>
                          ) : (
                            prop?.name
                          )}
                        </Typography>
                      ))}
                  </li>
                </CustomTooltip>
              </Grid>
            )
          )}
        </Grid>
        </Fragment>
      );
    });
  };

  const handleLogoClick = () => {
    // Handle superadmin layout - navigate to superadmin index
    if (layout === "/superadmin") {
      navigate("/superadmin/index", {
        state: { navigats: ["/index"] },
      });
      return;
    }
    
    if (location.pathname.includes("/staff-member")) {
      navigate(`/${CompanyUrl}/staff-member/index`, {
        state: { navigats: ["/index"] },
      });
    } else if (location.pathname.includes("/customers")) {
      navigate(`/${CompanyUrl}/customers/index`, {
        state: { navigats: ["/index"] },
      });
    } else {
      navigate(
        `/${CompanyUrl ? CompanyUrl : location.pathname.split("/")[1]}/index`,
        {
          state: { navigats: ["/index"] },
        }
      );
    }
  };
  const baseUrl = import.meta.env.VITE_BASE_API;
  const [staffData, setStaffData] = useState({});
  useEffect(() => {
    const fetchStaffData = async () => {
      try {
        const response = await AxiosInstance.get(
          `/v1/worker/get-permissions/${getItem(
            "worker_id"
          )}`
        );
        setStaffData(response?.data?.data?.permissions);
      } catch (error) {}
    };
    if (location.pathname.includes("/staff-member")) {
      fetchStaffData();
    }
  }, [location.pathname]);

  const [navCounts, setNavCounts] = useState(null);
  const [navCountsRefreshKey, setNavCountsRefreshKey] = useState(0);
  useEffect(() => {
    if (!useCjRedesign) {
      setNavCounts(null);
      return;
    }
    let cancelled = false;
    const fetchCounts = async () => {
      try {
        if (layout === "/:CompanyUrl" && getAuthProfile(tokenDecode)?.Role === "Company") {
          const res = await AxiosInstance.get(`/v1/graph/admin-counts`);
          if (!cancelled && res?.data?.data) setNavCounts(res.data.data);
        } else if (layout === "/:CompanyUrl/staff-member") {
          const wid = getItem("worker_id");
          if (!wid) {
            if (!cancelled) setNavCounts(null);
            return;
          }
          const res = await AxiosInstance.get(
            `/v1/graph/worker-dashboard-counts/${wid}`
          );
          if (!cancelled && res?.data?.data) setNavCounts(res.data.data);
        } else if (layout === "/:CompanyUrl/customers") {
          const cid = getItem("CustomerId");
          if (!cid) {
            if (!cancelled) setNavCounts(null);
            return;
          }
          const res = await AxiosInstance.get(
            `/v1/graph/customer-dashboard-counts/${cid}`
          );
          if (!cancelled && res?.data?.data) setNavCounts(res.data.data);
        } else if (!cancelled) setNavCounts(null);
      } catch {
        if (!cancelled) setNavCounts(null);
      }
    };
    fetchCounts();
    return () => {
      cancelled = true;
    };
  }, [
    useCjRedesign,
    layout,
    getAuthProfile(tokenDecode)?.Role,
    getAuthProfile(tokenDecode)?.CompanyId,
    location.pathname,
    navCountsRefreshKey,
  ]);

  // Let list pages request a fresh nav-count fetch after mutations
  // (delete / create / restore) without a full navigation.
  useEffect(() => {
    const handleRefresh = () => setNavCountsRefreshKey((k) => k + 1);
    window.addEventListener("sidebar-counts-refresh", handleRefresh);
    return () => window.removeEventListener("sidebar-counts-refresh", handleRefresh);
  }, []);

  const [createMenuAnchor, setCreateMenuAnchor] = useState(null);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
  const handleNavigation = (path, state) => {
    setCreateMenuAnchor(null);
    navigate(path, state);
    if (!isMediumScreen) closePopover();
  };

  const authProfile = getAuthProfile(tokenDecode);
  const sidebarDisplayName = buildSidebarDisplayName(authProfile);
  const sidebarRoleLabel = formatCjRoleLabel(authProfile?.Role);
  const sidebarInitials = buildSidebarInitials(
    sidebarDisplayName,
    authProfile?.Role
  );

  const sidebarNameTextRef = useRef(null);
  const [sidebarNameTruncated, setSidebarNameTruncated] = useState(false);
  const updateSidebarNameTruncation = useCallback(() => {
    const el = sidebarNameTextRef.current;
    if (!el) return;
    setSidebarNameTruncated(el.scrollWidth > el.clientWidth + 1);
  }, []);

  useLayoutEffect(() => {
    updateSidebarNameTruncation();
    const el = sidebarNameTextRef.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    const ro = new ResizeObserver(() => updateSidebarNameTruncation());
    ro.observe(el);
    return () => ro.disconnect();
  }, [sidebarDisplayName, isSidebarClosed, updateSidebarNameTruncation]);

  const profilePath =
    layout?.includes("staff-member") && CompanyUrl
      ? `/${CompanyUrl}/staff-member/profile`
      : layout?.includes("customers") && CompanyUrl
      ? `/${CompanyUrl}/customers/profile`
      : CompanyUrl
      ? `/${CompanyUrl}/profile`
      : layout === "/superadmin"
      ? "/superadmin/SuperAdminProfile"
      : null;

  const themePath =
    layout?.includes("staff-member") && CompanyUrl
      ? `/${CompanyUrl}/staff-member/settings/theme`
      : layout?.includes("customers") && CompanyUrl
      ? `/${CompanyUrl}/customers/settings/theme`
      : layout === "/superadmin"
      ? "/superadmin/settings/theme"
      : null;

  return (
    <>
      {/* Overlay for mobile - click to close sidebar */}
      {isMediumScreen && (
        <div
          className={`sidebar-overlay ${isSidebarDisplay ? "active" : ""}`}
          onClick={() => setIsSidebarDisplay(false)}
        />
      )}
      <nav
        className={`sidebar ${
          isDonationMode
            ? "bg-white-donor-color"
            : useCjRedesign
            ? "sidebar--cj-redesign"
            : "bg-blue-color"
        } sideBarScorrSetHere ${
          isSidebarClosed ? "close" : ""
        } ${isSidebarDisplay ? "" : "my-collapse"}`}
        style={{
          borderRight: isDonationMode
            ? "1px solid #68b2cb"
            : useCjRedesign
            ? "1px solid #1A3F5C"
            : "1px solid #0f2b46",
          borderRadius: isDonationMode ? "0px" : "",
          ...(useCjRedesign
            ? {
                display: "flex",
                flexDirection: "column",
                height: "100%",
                maxHeight: "100vh",
              }
            : {}),
        }}
      >
        <header>
          <i
            className=" toggle "
            style={{
              cursor: "pointer",
              /* CJ: white circular button — icon must be dark (not #EFF6FF or it vanishes). */
              color: useCjRedesign ? "#0F2B46" : "#333",
            }}
            onClick={() => {
              if (isMediumScreen) {
                setIsSidebarDisplay(!isSidebarDisplay);
              } else {
                toggleSidebar();
              }
            }}
          >
            {!isMediumScreen ? (
              <KeyboardArrowRightRoundedIcon />
            ) : (
              <CloseRoundedIcon />
            )}
          </i>
        </header>
          <Grid
            className="menu-bar"
            sx={{
              ...(useCjRedesign
                ? {
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    width: "100%",
                  }
                : {
                    overflowY: "auto",
                    overflowX: "hidden",
                  }),
              ...(!useCjRedesign
                ? {
                    "&::-webkit-scrollbar": { width: "2px" },
                    "&::-webkit-scrollbar-track": { background: "transparent" },
                    "&::-webkit-scrollbar-thumb": {
                      background: "rgba(255, 255, 255, 0.5)",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "rgba(255, 255, 255, 0.7)",
                    },
                    "&::-webkit-scrollbar-button": {
                      display: "none",
                      height: 0,
                      width: 0,
                    },
                    scrollbarWidth: "thin",
                    scrollbarColor: "rgba(255, 255, 255, 0.5) transparent",
                  }
                : {}),
            }}
          >
          <Grid
            sx={{
              flexShrink: useCjRedesign ? 0 : undefined,
              width: "100%",
            }}
          >
          <Grid
            className={`my-logo d-flex justify-content-ceter${
              useCjRedesign ? " sidebar-cj-logo-wrap" : ""
            }`}
            style={{
              marginLeft:
                isSidebarClosed ? "" : useCjRedesign ? "0" : "12px",
              // marginBottom: isDonationMode ? "" : "0px",
              minHeight: "60px",
            }}
            onClick={handleLogoClick}
          >
            {isLogoLoaded && (
              <>
                {isSidebarClosed ? (
                  <img
                    key={`logo-small-${currentLogoPath}-${logoUpdateTimestamp}`}
                    src={
                      currentLogoPath
                        ? `${uploadsUrl}/${currentLogoPath}?t=${logoUpdateTimestamp}`
                        : isDonationMode
                        ? logoDonor2 || "/placeholder.svg"
                        : logo2 || "/placeholder.svg"
                    }
                    alt="Logo"
                    style={{ cursor: "pointer" }}
                    className="SidebarSmallloos"
                    onError={(e) => {
                      // Logo failed to load - will use default
                    }}
                  />
                ) : (
                  <img
                    key={`logo-big-${currentLogoPath}-${logoUpdateTimestamp}`}
                    src={
                      currentLogoPath
                        ? `${uploadsUrl}/${currentLogoPath}?t=${logoUpdateTimestamp}`
                        : isDonationMode
                        ? logoDonor || "/placeholder.svg"
                        : logo || "/placeholder.svg"
                    }
                    alt="Logo"
                    style={{ cursor: "pointer" }}
                    className="SidebarBigLogos"
                    onError={(e) => {
                      // Logo failed to load - will use default
                    }}
                  />
                )}
              </>
            )}
          </Grid>
          {getAuthProfile(tokenDecode)?.Role === "Company" && !isDonationMode && (
            <>
              {(CompanyUrl || location.pathname.includes("/staff-member")) &&
                (!location.pathname.includes("/staff-member") ||
                  staffData?.CustomersProperties
                    ?.ViewCreateAndEdit ||
                  staffData?.CustomersProperties
                    ?.ViewCreateEditAndDelete ||
                  staffData?.Jobs?.JViewCreateAndEdit ||
                  staffData?.Jobs?.JViewCreateEditAndDelete) && (
                  <>
                    {!useCjRedesign && !isMediumScreen && (
                      <WhiteButton
                        id="PopoverLegacy"
                        type="button"
                        style={{
                          color: "#ffffff",
                          backgroundColor: "transparent",
                          display: "flex",
                          alignItems: "center",
                          marginLeft: "35px",
                          fontWeight: 600,
                          marginTop: "15px",
                          marginBottom: "5px",
                          border: "none",
                          padding: "8px 16px",
                          boxSizing: "border-box",
                        }}
                        className="create-button mb-2 text-white-color"
                        onClick={togglePopover}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            "rgba(255, 255, 255, 0.1)")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            "transparent")
                        }
                        label={
                          <>
                            {isSidebarClosed ? (
                              <img
                                src={CreateWhite || "/placeholder.svg"}
                                alt="Create Icon"
                                style={{
                                  marginRight: "30px",
                                  marginLeft: "-17px",
                                  height: "18px",
                                  width: "18px",
                                }}
                              />
                            ) : (
                              <img
                                src={CreateWhite || "/placeholder.svg"}
                                alt="Create Icon"
                                style={{
                                  marginRight: "20px",
                                  marginLeft: "2px",
                                  height: "18px",
                                  width: "18px",
                                }}
                              />
                            )}
                            {!isSidebarClosed && "Create"}
                          </>
                        }
                      />
                    )}
                    {useCjRedesign || isMediumScreen ? (
                      <>
                        <Box
                          className={`dropdownBottom${
                            useCjRedesign ? " sidebar-cj-create-dropdown" : ""
                          }`}
                        >
                          {useCjRedesign ? (
                            <button
                              type="button"
                              className="create-button mb-2 text-white-color cj-create-toggle"
                              style={{
                                color: "#ffffff",
                                backgroundColor: "#D4943A",
                                border: "none",
                                display: "flex",
                                alignItems: "center",
                                marginLeft: "12px",
                                marginRight: "12px",
                                width: !isSidebarClosed
                                  ? "calc(100% - 24px)"
                                  : undefined,
                                fontWeight: 600,
                                marginTop: "15px",
                                marginBottom: "5px",
                                padding: "10px 18px",
                                borderRadius: "6px",
                                justifyContent: "center",
                                boxSizing: "border-box",
                                boxShadow: "none",
                                cursor: "pointer",
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setCreateMenuAnchor((el) =>
                                  el ? null : e.currentTarget
                                );
                              }}
                            >
                              {isSidebarClosed ? (
                                <span
                                  style={{
                                    fontSize: "20px",
                                    fontWeight: 700,
                                    lineHeight: 1,
                                  }}
                                  aria-hidden
                                >
                                  +
                                </span>
                              ) : null}
                              {!isSidebarClosed && "+ Create New"}
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="drop-down-btn dropdownBotton create-button mb-2 text-white-color"
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                                marginLeft: "40px",
                                marginBottom: "-10px",
                                color: "#ffffff",
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 16px",
                                transition: "background-color 0.3s ease",
                                cursor: "pointer",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "rgba(255, 255, 255, 0.1)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "transparent";
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setCreateMenuAnchor((el) =>
                                  el ? null : e.currentTarget
                                );
                              }}
                            >
                              {isSidebarClosed ? (
                                <img
                                  src={CreateWhite || "/placeholder.svg"}
                                  alt="Create Icon"
                                  style={{
                                    marginRight: "30px",
                                    marginLeft: "-15px",
                                    height: "18px",
                                    width: "18px",
                                  }}
                                  className="sidebarClosedSideIcon"
                                />
                              ) : (
                                <img
                                  src={CreateWhite || "/placeholder.svg"}
                                  alt="Create Icon"
                                  style={{
                                    marginRight: "20px",
                                    marginLeft: "2px",
                                    height: "18px",
                                    width: "18px",
                                  }}
                                />
                              )}
                              {!isSidebarClosed && "Create"}
                            </button>
                          )}
                        </Box>
                        <Menu
                          className="sidebar-create-mui-menu"
                          anchorEl={createMenuAnchor}
                          open={Boolean(createMenuAnchor)}
                          onClose={() => setCreateMenuAnchor(null)}
                          disableScrollLock
                          disableAutoFocusItem
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                          elevation={0}
                          PaperProps={{
                            sx: {
                              zIndex: 1400,
                              borderRadius: "12px",
                              border: "1px solid #D1D5DB",
                              boxShadow: "var(--shadow-xl)",
                              py: 0.5,
                              px: 0,
                              minWidth: SIDEBAR_CREATE_MENU_MIN_PX,
                              width: "max-content",
                              maxWidth: "calc(100vw - 24px)",
                              mt: 0.75,
                              ml: useCjRedesign ? 1.5 : 0,
                              overflow: "visible",
                            },
                          }}
                          MenuListProps={{
                            dense: true,
                            disablePadding: true,
                            sx: {
                              py: 0.25,
                              width: "100%",
                              minWidth: SIDEBAR_CREATE_MENU_MIN_PX,
                              boxSizing: "border-box",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "stretch",
                            },
                          }}
                        >
                          {(!location.pathname.includes("/staff-member") ||
                            staffData?.CustomersProperties
                              ?.ViewCreateAndEdit ||
                            staffData?.CustomersProperties
                              ?.ViewCreateEditAndDelete) && (
                            <MenuItem
                              sx={sidebarCreateMenuItemSx}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (isMediumScreen) {
                                  setIsSidebarDisplay(!isSidebarDisplay);
                                }
                                let navigationState = [];
                                if (
                                  location?.pathname?.includes("/staff-member")
                                ) {
                                  navigationState = [
                                    "/index",
                                    "/worker-customer",
                                    "/add-customer",
                                  ];
                                } else if (
                                  !location?.pathname?.includes("/staff-member")
                                ) {
                                  navigationState = [
                                    "/index",
                                    "/customer",
                                    "/add-customer",
                                  ];
                                }
                                handleNavigation(
                                  !location?.pathname?.includes("/staff-member")
                                    ? `/${CompanyUrl}/add-customer`
                                    : `/${CompanyUrl}/staff-member/add-customer`,
                                  {
                                    state: {
                                      navigats: navigationState,
                                    },
                                  }
                                );
                              }}
                            >
                              <SidebarCreateMenuIconTile
                                kind="customer"
                                useCjIcons={useCjRedesign}
                                imgSrc={Client}
                              />
                              <Typography sx={sidebarCreateMenuLabelSx}>
                                Customer
                              </Typography>
                            </MenuItem>
                          )}
                          {(!location.pathname.includes("/staff-member") ||
                            staffData?.Quotes?.ViewCreateAndEdit ||
                            staffData?.Quotes?.ViewCreateEditAndDelete) && (
                            <MenuItem
                              sx={sidebarCreateMenuItemSx}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (isMediumScreen) {
                                  setIsSidebarDisplay(!isSidebarDisplay);
                                }
                                let navigationPath = [];
                                if (
                                  !location.pathname.includes("/staff-member")
                                ) {
                                  navigationPath = [
                                    "/index",
                                    "/quotes",
                                    "/add-quotes",
                                  ];
                                } else {
                                  navigationPath = [
                                    "/index",
                                    "/worker-quote",
                                    "/add-quotes",
                                  ];
                                }
                                handleNavigation(
                                  !location.pathname.includes("/staff-member")
                                    ? `/${CompanyUrl}/add-quotes`
                                    : `/${CompanyUrl}/staff-member/add-quotes`,
                                  {
                                    state: {
                                      navigats: navigationPath,
                                    },
                                  }
                                );
                              }}
                            >
                              <SidebarCreateMenuIconTile
                                kind="quote"
                                useCjIcons={useCjRedesign}
                                imgSrc={Quote}
                              />
                              <Typography sx={sidebarCreateMenuLabelSx}>
                                Quote
                              </Typography>
                            </MenuItem>
                          )}
                          {(!location.pathname.includes("/staff-member") ||
                            staffData?.ServiceRequests?.ViewCreateAndEdit ||
                            staffData?.ServiceRequests?.ViewCreateEditAndDelete) && (
                            <MenuItem
                              sx={sidebarCreateMenuItemSx}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (isMediumScreen) {
                                  setIsSidebarDisplay(!isSidebarDisplay);
                                }
                                let navigationPath = [];
                                if (!location.pathname.includes("/staff-member")) {
                                  navigationPath = [
                                    "/index",
                                    "/service-requests",
                                    "/add-service-requests",
                                  ];
                                } else {
                                  navigationPath = [
                                    "/index",
                                    "/worker-service-requests",
                                    "/add-service-requests",
                                  ];
                                }
                                handleNavigation(
                                  !location.pathname.includes("/staff-member")
                                    ? `/${CompanyUrl}/add-service-requests`
                                    : `/${CompanyUrl}/staff-member/add-service-requests`,
                                  {
                                    state: {
                                      navigats: navigationPath,
                                    },
                                  }
                                );
                              }}
                            >
                              <SidebarCreateMenuIconTile
                                kind="request"
                                useCjIcons={useCjRedesign}
                                imgSrc={Quote}
                              />
                              <Typography sx={sidebarCreateMenuLabelSx}>
                                Request
                              </Typography>
                            </MenuItem>
                          )}
                          {((!location.pathname.includes("/staff-member") &&
                            CompanyUrl) ||
                            staffData?.Jobs?.JViewCreateAndEdit ||
                            staffData?.Jobs?.JViewCreateEditAndDelete) && (
                            <MenuItem
                              sx={sidebarCreateMenuItemSx}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (isMediumScreen) {
                                  setIsSidebarDisplay(!isSidebarDisplay);
                                }
                                if (!location.pathname.includes("/staff-member")) {
                                  handleNavigation(`/${CompanyUrl}/add-contract`, {
                                    state: {
                                      navigats: [
                                        "/index",
                                        "/contract",
                                        "/add-contract",
                                      ],
                                    },
                                  });
                                } else {
                                  handleNavigation(
                                    `/${CompanyUrl}/staff-member/add-contract`,
                                    {
                                      state: {
                                        navigats: [
                                          "/index",
                                          "/worker-contract",
                                          "/add-contract",
                                        ],
                                      },
                                    }
                                  );
                                }
                              }}
                            >
                              <SidebarCreateMenuIconTile
                                kind="contract"
                                useCjIcons={useCjRedesign}
                                imgSrc={Contract}
                              />
                              <Typography sx={sidebarCreateMenuLabelSx}>
                                Contract
                              </Typography>
                            </MenuItem>
                          )}
                          {!isDonationMode &&
                            ((!location.pathname.includes("/staff-member") &&
                              CompanyUrl) ||
                              staffData?.Jobs?.JViewCreateAndEdit ||
                              staffData?.Jobs?.JViewCreateEditAndDelete) && (
                              <MenuItem
                                sx={sidebarCreateMenuItemSx}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (isMediumScreen) {
                                    setIsSidebarDisplay(!isSidebarDisplay);
                                  }
                                  handleNavigation(`/${CompanyUrl}/invoice`, {
                                    state: {
                                      navigats: ["/index", "/invoice"],
                                    },
                                  });
                                }}
                              >
                                <SidebarCreateMenuIconTile
                                  kind="invoice"
                                  useCjIcons={useCjRedesign}
                                  imgSrc={Invoice}
                                />
                                <Typography sx={sidebarCreateMenuLabelSx}>
                                  Invoice
                                </Typography>
                              </MenuItem>
                            )}
                        </Menu>
                      </>
                    ) : (
                      <MyPopoverComponent
                        popoverOpen={popoverOpen}
                        togglePopover={togglePopover}
                        handleNavigation={handleNavigation}
                        CompanyUrl={CompanyUrl}
                        staffData={staffData}
                      />
                    )}
                  </>
                )}
            </>
          )}
          </Grid>
          <Grid
            sx={{
              ...(useCjRedesign
                ? {
                    flex: 1,
                    minHeight: 0,
                    overflowY: "auto",
                    overflowX: "hidden",
                    "&::-webkit-scrollbar": { width: "2px" },
                    "&::-webkit-scrollbar-track": { background: "transparent" },
                    "&::-webkit-scrollbar-thumb": {
                      background: "rgba(255, 255, 255, 0.35)",
                      borderRadius: "10px",
                    },
                    scrollbarWidth: "thin",
                    scrollbarColor: "rgba(255, 255, 255, 0.35) transparent",
                  }
                : {}),
            }}
          >
          <Grid
            className="menu pt-1"
            style={{
              paddingBottom:
                useCjRedesign ? 0 : isImpersonated ? "80px" : "0px",
            }}
          >
            {createLinks(routesData ? routesData : routes)}
          </Grid>
          </Grid>
        </Grid>

        {useCjRedesign && (
          <>
            <Grid
              className="sidebar-cj-bottom"
              sx={{
                flexShrink: 0,
                width: "100%",
                borderTop: "1px solid rgba(255,255,255,0.08)",
                px: isSidebarClosed ? 0.5 : 1.75,
                py: 1.5,
                display: "flex",
                alignItems: "center",
                gap: isSidebarClosed ? 1 : 1.5,
                justifyContent: isSidebarClosed ? "center" : "flex-start",
              }}
            >
              {isSidebarClosed ? (
                <IconButton
                  size="small"
                  onClick={(e) => setProfileMenuAnchor(e.currentTarget)}
                  sx={{ p: 0 }}
                  aria-label="Account menu"
                >
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      background: "#D4943A",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 700,
                      fontSize: 14,
                    }}
                  >
                    {sidebarInitials}
                  </div>
                </IconButton>
              ) : (
                <>
                  <div
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      background: "#D4943A",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 700,
                      fontSize: 14,
                      flexShrink: 0,
                    }}
                  >
                    {sidebarInitials}
                  </div>
                  <div
                    style={{
                      flex: 1,
                      minWidth: 0,
                      overflow: "hidden",
                      paddingLeft: 4,
                    }}
                  >
                    <Tooltip
                      title={sidebarDisplayName}
                      placement="top-start"
                      enterDelay={350}
                      disableHoverListener={
                        !sidebarDisplayName || !sidebarNameTruncated
                      }
                      componentsProps={{
                        tooltip: {
                          sx: {
                            bgcolor: "rgba(15, 23, 42, 0.96)",
                            color: "#fff",
                            fontSize: 13,
                            fontWeight: 500,
                            maxWidth: 280,
                            px: 1.25,
                            py: 0.75,
                            border: "1px solid rgba(255,255,255,0.12)",
                            boxShadow: "var(--shadow-xl)",
                          },
                        },
                      }}
                    >
                      <Typography
                        ref={sidebarNameTextRef}
                        noWrap
                        component="div"
                        style={{
                          color: "#fff",
                          fontWeight: 600,
                          fontSize: 14,
                          minWidth: 0,
                          width: "100%",
                        }}
                      >
                        {sidebarDisplayName}
                      </Typography>
                    </Tooltip>
                    <Typography
                      noWrap
                      style={{
                        color: "rgba(255,255,255,0.55)",
                        fontSize: 12,
                      }}
                    >
                      {sidebarRoleLabel}
                    </Typography>
                  </div>
                  <IconButton
                    size="small"
                    onClick={(e) => setProfileMenuAnchor(e.currentTarget)}
                    sx={{
                      color: "rgba(255,255,255,0.65)",
                      flexShrink: 0,
                      ml: 0.5,
                    }}
                    aria-label="Open menu"
                  >
                    <MoreVertIcon fontSize="small" />
                  </IconButton>
                </>
              )}
            </Grid>
            <Menu
              anchorEl={profileMenuAnchor}
              open={Boolean(profileMenuAnchor)}
              onClose={() => setProfileMenuAnchor(null)}
              /* Expanded: open to the RIGHT of the sidebar so it doesn’t cover nav rows */
              anchorOrigin={
                isSidebarClosed
                  ? { vertical: "bottom", horizontal: "center" }
                  : { vertical: "center", horizontal: "right" }
              }
              transformOrigin={
                isSidebarClosed
                  ? { vertical: "top", horizontal: "center" }
                  : { vertical: "center", horizontal: "left" }
              }
              disableScrollLock
              PaperProps={{
                sx: {
                  borderRadius: "10px",
                  minWidth: 196,
                  ml: isSidebarClosed ? 0 : 0.75,
                  bgcolor: "#1A3F5C",
                  backgroundImage: "none",
                  border: "1px solid rgba(255,255,255,0.14)",
                  boxShadow: "var(--shadow-xl)",
                  zIndex: 1400,
                  overflow: "hidden",
                  mt: isSidebarClosed ? 0.5 : 0,
                },
              }}
              MenuListProps={{
                dense: true,
                sx: { py: 0.5, bgcolor: "transparent" },
              }}
            >
              {profilePath && (
                <MenuItem
                  onClick={() => {
                    setProfileMenuAnchor(null);
                    navigate(profilePath, {
                      state: {
                        navigats:
                          layout === "/superadmin"
                            ? ["/index", "SuperAdminProfile"]
                            : ["/index", "/profile"],
                      },
                    });
                  }}
                  sx={{
                    color: "#fff",
                    py: 1.1,
                    px: 1.5,
                    fontSize: 14,
                    fontWeight: 500,
                    "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
                  }}
                >
                  <ListItemIcon sx={{ minWidth: 38, color: "#fff" }}>
                    <PersonIcon fontSize="small" />
                  </ListItemIcon>
                  Profile
                </MenuItem>
              )}
              {themePath && (
                <>
                  <MenuItem
                    onClick={() => {
                      setProfileMenuAnchor(null);
                      navigate(themePath, {
                        state: {
                          navigats: ["/index", "/settings/theme"],
                        },
                      });
                    }}
                    sx={{
                      color: "#fff",
                      py: 1.1,
                      px: 1.5,
                      fontSize: 14,
                      fontWeight: 500,
                      "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 38, color: "#fff" }}>
                      <PaletteOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    Mode
                  </MenuItem>
                  <Divider
                    sx={{ borderColor: "rgba(255,255,255,0.12)", my: 0.25 }}
                  />
                </>
              )}
              <MenuItem
                onClick={() => {
                  setProfileMenuAnchor(null);
                  logout(navigate);
                }}
                sx={{
                  color: "#fff",
                  py: 1.1,
                  px: 1.5,
                  fontSize: 14,
                  fontWeight: 500,
                  "&:hover": { bgcolor: "rgba(220,38,38,0.2)" },
                }}
              >
                <ListItemIcon sx={{ minWidth: 38, color: "#fff" }}>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                Log Out
              </MenuItem>
            </Menu>
          </>
        )}

        {/* Super Admin Return Button - Only visible when impersonating */}
        {isImpersonated && (
          <Grid
            style={{
              position: useCjRedesign ? "relative" : "absolute",
              bottom: useCjRedesign ? undefined : 0,
              left: useCjRedesign ? undefined : 0,
              right: useCjRedesign ? undefined : 0,
              flexShrink: useCjRedesign ? 0 : undefined,
              padding: "15px",
              backgroundColor: isDonationMode
                ? "#ffffff"
                : useCjRedesign
                ? "#0B2238"
                : "#0f2b46",
              borderTop: `2px solid ${
                isDonationMode ? "#68b2cb" : useCjRedesign ? "#1A3F5C" : "#0f2b46"
              }`,
            }}
          >
            <Grid
              onClick={() => {
                logout(navigate, true);
              }}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: isSidebarClosed ? "center" : "space-between",
                padding: "12px 16px",
                backgroundColor: isDonationMode
                  ? "#66D59A"
                  : useCjRedesign
                  ? "#D4943A"
                  : "var(--amber)",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = isDonationMode
                  ? "#5BB5C9"
                  : useCjRedesign
                  ? "#C27820"
                  : "#d17a3a";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = isDonationMode
                  ? "#66D59A"
                  : useCjRedesign
                  ? "#D4943A"
                  : "var(--amber)";
              }}
            >
              {!isSidebarClosed && (
                <Typography
                  style={{
                    color: "#ffffff",
                    fontSize: "14px",
                    fontWeight: "600",
                  }}
                >
                  Super Admin
                </Typography>
              )}
              <ExitToAppIcon
                style={{
                  color: "#ffffff",
                  fontSize: "20px",
                  transform: "rotate(180deg)",
                }}
              />
            </Grid>
          </Grid>
        )}
      </nav>
    </>
  );
};

export default Sidebar;
